<form #cashboxForm="ngForm" (ngSubmit)="openCashbox()">
    <div class="modal-content">
        <h5 class="modal-title" *ngIf="!cashboxService.openedFromScFinish">Abrir caja</h5>
        <h5 class="modal-title" *ngIf="cashboxService.openedFromScFinish">¿Deseas abrir caja antes de realizar tu primera venta del día?</h5>
        <p class="modal-subtitle">Selecciona las cuentas que participan en el cierre de hoy.</p>

        <div class="text-center py-4" *ngIf="loading">
            <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
            <span class="text-muted ms-2">Cargando métodos de pago…</span>
        </div>

        <div class="empty-state" *ngIf="!loading && !loadError && !rows.length">
            <i class="fa fa-exclamation-triangle me-1"></i>
            No hay métodos de pago configurados para el cierre de caja. Configúralos en Comercio &gt; Cierre de caja.
        </div>

        <div class="entries-list" *ngIf="!loading && rows.length">
            <div class="entry-row" *ngFor="let row of rows; trackBy: undefined" [class.entry-row--selected]="row.selected">
                <div class="entry-check" (click)="onToggleRow(row)">
                    <input type="checkbox" class="form-check-input" [checked]="row.selected" (click)="$event.stopPropagation(); onToggleRow(row)" [attr.aria-label]="row.displayName" />
                </div>

                <div class="entry-name" (click)="onToggleRow(row)">
                    <span class="entry-name__title">{{ row.displayName }}</span>
                    <span class="entry-name__subtitle">{{ row.bankAccountName }}</span>
                </div>

                <div class="entry-currency">
                    <span class="currency-badge" [class.currency-badge--usd]="row.currency === 'USD'">{{ row.currency === 'USD' ? '$' : 'Bs' }}</span>
                </div>

                <div class="entry-amount">
                    <div class="amount-field" *ngIf="row.selected">
                        <span class="amount-field__label">Monto inicial</span>
                        <input
                            class="amount-field__input"
                            type="number"
                            min="0"
                            step="0.01"
                            max="9999999999.99"
                            placeholder="0,00"
                            [(ngModel)]="row.initialAmount"
                            [name]="'initialAmount_' + row.bankAccountId"
                            (input)="validateAmount($event, row)"
                            finaBlurOnWheel
                        />
                    </div>
                    <span class="text-muted text-sm" *ngIf="!row.selected">No participa hoy</span>
                </div>
            </div>
        </div>

        <div class="warning-message mt-2" *ngIf="!loading && hasSelection">
            <small class="text-warning">
                <i class="fa fa-exclamation-triangle me-1"></i>
                <strong>El cierre de hoy solo contabilizará los movimientos de las {{ selectedRows.length }} cuentas seleccionadas.</strong>
            </small>
        </div>

        <!-- Los métodos participantes se definen en configuración, no acá: al abrir solo se
             elige cuáles entran hoy. -->
        <div class="config-hint mt-2" *ngIf="!loading && !loadError">
            <i class="fa fa-info-circle me-1"></i>
            ¿Te falta un método de pago?
            <ng-container *ngIf="(userService.user$ | async)?.permissions?.COMMERCE?.includes('enable-cashbox'); else configHintPlain">
                <a class="config-hint__link" (click)="goToConfig()">Agrégalo en Comercio &gt; Cierre de caja</a>.
            </ng-container>
            <ng-template #configHintPlain>Pídele al administrador que lo agregue en Comercio &gt; Cierre de caja.</ng-template>
        </div>

        <div class="warning-message mt-2" *ngIf="missingPaymentMethodNames.length">
            <small class="text-warning">
                <i class="fa fa-exclamation-triangle me-1"></i>
                Estos métodos están configurados pero ya no se pueden usar: {{ missingPaymentMethodNames.join(', ') }}.
            </small>
        </div>

        <div class="totals-box" *ngIf="!loading && hasSelection">
            <span class="totals-box__label">Apertura declarada</span>
            <span class="totals-box__value">
                <ng-container *ngFor="let total of openingTotals; let last = last">
                    {{ total.total | number : '1.2-2' }} {{ total.currency === 'USD' ? '$' : 'Bs' }}<span *ngIf="!last"> · </span>
                </ng-container>
            </span>
        </div>

        <div class="modal-footer d-flex align-items-center justify-content-center gap-2">
            <button class="btn btn-cancel" (click)="closeModal()" type="button">Cancelar</button>
            <button
                class="btn btn-open-modal"
                (click)="openCashbox()"
                type="button"
                [disabled]="loading || saving || !hasSelection || hasInvalidAmount || !(userService.user$ | async)?.permissions?.POS?.includes('open-cashbox')"
            >
                {{ saving ? 'Abriendo…' : 'Abrir caja' }}
            </button>
        </div>
    </div>
</form>
